import React, { Component } from 'react'
import { Link } from 'react-router'
import Tabs from './tabs'
import { EDIT_WEDDING_HALL_PATH } from '@components/Hotel/constant'
import { HeaderView } from '@merchant-backend/common-components'
import { Button } from 'hljd'
import { hashHistory } from 'react-router'
import { Provider } from 'mobx-react'
import Store from './store'

export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }

  render() {
    const header = [
      <Link to="/localMerchant/siteManage">场地管理</Link>,
      '场地排序'
    ]
    return (
      <Provider store={this.store}>
        <HeaderView
          header={header}
          title="场地排序"
          extra={
            <Button
              type="primary"
              onClick={() => hashHistory.push(EDIT_WEDDING_HALL_PATH)}
            >
              发布场地
            </Button>
          }
        >
          <Tabs />
        </HeaderView>
      </Provider>
    )
  }
}
